<template lang="pug">
.listing-empty-state
  v-card.d-flex.flex-column.align-center.justify-center.pa-8.border-dashed.round-2xl(outlined)
    v-btn.basic400.mb-6(v-if="iconName" icon)
      v-icon(size="25") {{ iconName }}
    div.text-center
      .text-md.font-semibold(v-if="primaryText")  {{ primaryText }}
      .text-sm.font-normal.neutral500--text(v-if="secondaryText") {{ secondaryText }}
    v-btn.button-sm.mt-8(v-if="btnText" @click="$emit('btnClicked')" depressed dark color="neutral700" :loading="loading") {{ btnText }}
</template>

<script>

export default {
  name: 'ListingEmptyState',
  props: {
    iconName: {
      type: String,
      default: null
    },
    primaryText: {
      type: String,
      default: null
    },
    secondaryText: {
      type: String,
      default: null
    },
    btnText: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean
    }
  },
}
</script>

<style scoped>
</style>
